


















import './AuthenticatorWrapper.scss'
import { defineComponent } from '@vue/composition-api'
import Media from '@/modules/kisweui/components/Media'
import KisweStudioLogo from '@/modules/kisweui/components/KisweStudioLogo'

export default defineComponent({
  name: 'AuthenticatorWrapper',
  components: {
    Media,
    KisweStudioLogo
  }
})
